module.exports = {
    OBJ_KEY_JWT_TOKEN: 'authToken',
    OBJ_KEY_USER_INFO: 'userData'
}